import 'bootstrap/dist/css/bootstrap.min.css';
import Marquee from 'react-fast-marquee';

// Import images
import logo1 from '../../assets/banner1.png';
import logo2 from '../../assets/banner2.png';
import logo3 from '../../assets/banner3.png';
import logo4 from '../../assets/banner4.png';
import logo5 from '../../assets/banner5.png';
import logo6 from '../../assets/banner6.png';
import logo7 from '../../assets/banner7.png';
import logo8 from '../../assets/banner8.png';
import logo9 from '../../assets/banner9.png';
import logo10 from '../../assets/banner10.png';
import logo11 from '../../assets/banner11.png';
import logo12 from '../../assets/banner12.png';
import logo13 from '../../assets/banner13.png';
import logo14 from '../../assets/banner14.png';
import logo15 from '../../assets/banner15.png';
import logo16 from '../../assets/banner16.png';
import logo17 from '../../assets/banner17.png';
import logo18 from '../../assets/banner18.png';
import logo19 from '../../assets/banner19.png';
import logo20 from '../../assets/banner20.png';
import logo21 from '../../assets/banner21.png';
import logo22 from '../../assets/banner22.png';
import logo23 from '../../assets/banner23.png';
import logo24 from '../../assets/banner24.png';
import logo25 from '../../assets/banner25.png';
import logo26 from '../../assets/banner26.png';
import logo27 from '../../assets/banner27.png';

function ImageMarquee() {
    return (
        <section className="bg-light py-4">
            <div className="container text-center">
               
                <Marquee speed={50} pauseOnHover gradient={false}>
                    <img src={logo1} alt="Logo 1" className="me-4 rounded shadow-sm marquee-img" />
                    <img src={logo2} alt="Logo 2" className="me-4 rounded shadow-sm marquee-img" />
                    <img src={logo3} alt="Logo 3" className="me-4 rounded shadow-sm marquee-img" />
                    <img src={logo4} alt="Logo 4" className="me-4 rounded shadow-sm marquee-img" />
                    <img src={logo5} alt="Logo 5" className="me-4 rounded shadow-sm marquee-img" />
                    <img src={logo6} alt="Logo 6" className="me-4 rounded shadow-sm marquee-img" />
                    <img src={logo7} alt="Logo 7" className="me-4 rounded shadow-sm marquee-img" />
                    <img src={logo8} alt="Logo 8" className="me-4 rounded shadow-sm marquee-img" />
                    <img src={logo9} alt="Logo 9" className="me-4 rounded shadow-sm marquee-img" />
                    <img src={logo10} alt="Logo 10" className="me-4 rounded shadow-sm marquee-img" />
                    <img src={logo11} alt="Logo 11" className="me-4 rounded shadow-sm marquee-img" />
                    <img src={logo12} alt="Logo 12" className="me-4 rounded shadow-sm marquee-img" />
                    <img src={logo13} alt="Logo 13" className="me-4 rounded shadow-sm marquee-img" />
                    <img src={logo14} alt="Logo 14" className="me-4 rounded shadow-sm marquee-img" />
                    <img src={logo15} alt="Logo 15" className="me-4 rounded shadow-sm marquee-img" />
                    <img src={logo16} alt="Logo 16" className="me-4 rounded shadow-sm marquee-img" />
                    <img src={logo17} alt="Logo 17" className="me-4 rounded shadow-sm marquee-img" />
                    <img src={logo18} alt="Logo 18" className="me-4 rounded shadow-sm marquee-img" />
                    <img src={logo19} alt="Logo 19" className="me-4 rounded shadow-sm marquee-img" />
                    <img src={logo20} alt="Logo 20" className="me-4 rounded shadow-sm marquee-img" />
                    <img src={logo21} alt="Logo 21" className="me-4 rounded shadow-sm marquee-img" />
                    <img src={logo22} alt="Logo 22" className="me-4 rounded shadow-sm marquee-img" />
                    <img src={logo23} alt="Logo 23" className="me-4 rounded shadow-sm marquee-img" />
                    <img src={logo24} alt="Logo 24" className="me-4 rounded shadow-sm marquee-img" />
                    <img src={logo25} alt="Logo 25" className="me-4 rounded shadow-sm marquee-img" />
                    <img src={logo26} alt="Logo 26" className="me-4 rounded shadow-sm marquee-img" />
                    <img src={logo27} alt="Logo 27" className="me-4 rounded shadow-sm marquee-img" />
                </Marquee>
            </div>
        </section>
    );
}

export default ImageMarquee;
